var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSortDurationLongToShort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3h6v2H6V3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16a3 3 0 0 1-3-3h3v-3a3 3 0 1 1 0 6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 13a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-2 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16h-2l3 4 3-4h-2V6h-2v10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSortDurationLongToShort);
export default __webpack_public_path__ + "static/media/ic_action_sort_duration_long_to_short.56ddd136c0fc130721eb6da4a3da64c5.svg";
export { ForwardRef as ReactComponent };